import comp from "./Step2";
export default comp;
